// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__VPtqA","content":"Consent_content__1Dl_z","footer":"Consent_footer__2sq9U"};